import { USER_PROJECT_ITEMS_PER_PAGE } from '../../../users/user-detail/user-projects-table';
import {
  Actions,
  ASSIGN_USER_AS_ORG_ADMIN_SUCCEEDED,
  CHANGE_PROJECT_OWNER,
  FETCH_USERS,
  FETCH_USERS_SUCCEEDED,
  GET_PROJECTS_FOR_SELECTED_USER,
  GET_PROJECTS_FOR_SELECTED_USER_FAILED,
  GET_PROJECTS_FOR_SELECTED_USER_SUCCEEDED,
  GET_REPORTS_FOR_SELECTED_USER,
  GET_REPORTS_FOR_SELECTED_USER_SUCCEEDED,
  GET_SELECTED_USER,
  GET_SELECTED_USER_FAILED,
  GET_SELECTED_USER_SUCCEEDED,
  GET_TEAMS_FOR_SELECTED_USER,
  GET_TEAMS_FOR_SELECTED_USER_FAILED,
  GET_TEAMS_FOR_SELECTED_USER_SUCCEEDED,
  REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_SUCCEEDED,
  SET_USER_FAVORITE_PROJECT,
  SET_USER_FAVORITE_REPORT,
} from './actions';
import { IUsersState } from './types';

const initialState: IUsersState = {
  list: {
    queriedAtLeastOnce: false,
    items: [],
    loading: false,
  },
  totalUsers: null,
  selectedUser: null,
  selectedUserIsLoading: false,
  teamsForSelectedUserList: {
    queriedAtLeastOnce: false,
    items: [],
    loading: false,
    total: 0,
  },
  reportsForSelectedUserList: {
    queriedAtLeastOnce: false,
    items: [],
    loading: false,
    total: 0,
  },
  projectsForSelectedUserList: {
    queriedAtLeastOnce: false,
    items: [],
    loading: false,
    total: 0,
  },
};

const reducer = (
  state: IUsersState = initialState,
  action: Actions
): IUsersState => {
  switch (action.type) {
    case FETCH_USERS:
      return {
        ...state,
        list: {
          ...state.list,
          items: action.payload.page === 1 ? [] : state.list.items,
          loading: true,
        },
      };

    case FETCH_USERS_SUCCEEDED:
      return {
        ...state,
        list: {
          ...state.list,
          items: [...state.list.items, ...action.payload.users],
          loading: false,
        },
        totalUsers: action.payload.total,
      };
    case GET_SELECTED_USER:
      return {
        ...state,
        selectedUserIsLoading: true,
        selectedUser: null as null,
      };
    case GET_SELECTED_USER_SUCCEEDED:
      return {
        ...state,
        selectedUserIsLoading: false,
        selectedUser: action.payload,
      };
    case GET_SELECTED_USER_FAILED:
      return {
        ...state,
        selectedUserIsLoading: false,
      };
    case GET_TEAMS_FOR_SELECTED_USER:
      return {
        ...state,
        teamsForSelectedUserList: {
          ...state.teamsForSelectedUserList,
          loading: true,
          items:
            action.payload.page === 1 || action.payload.page === undefined
              ? []
              : state.teamsForSelectedUserList.items,
        },
      };
    case GET_TEAMS_FOR_SELECTED_USER_SUCCEEDED:
      return {
        ...state,
        teamsForSelectedUserList: {
          ...state.teamsForSelectedUserList,
          loading: false,
          items: [
            ...state.teamsForSelectedUserList.items,
            ...action.payload.teams,
          ],
          total: action.payload.total,
        },
      };
    case GET_REPORTS_FOR_SELECTED_USER:
      return {
        ...state,
        reportsForSelectedUserList: {
          ...state.reportsForSelectedUserList,
          loading: true,
          items:
            action.payload.page === 1 || action.payload.page === undefined
              ? []
              : state.reportsForSelectedUserList.items,
        },
      };
    case GET_REPORTS_FOR_SELECTED_USER_SUCCEEDED:
      return {
        ...state,
        reportsForSelectedUserList: {
          ...state.teamsForSelectedUserList,
          loading: false,
          items: [
            ...state.reportsForSelectedUserList.items,
            ...action.payload.reports,
          ],
          total: action.payload.total,
        },
      };
    case GET_TEAMS_FOR_SELECTED_USER_FAILED:
      return {
        ...state,
        teamsForSelectedUserList: {
          ...state.teamsForSelectedUserList,
          loading: false,
          items: [],
        },
      };
    case GET_PROJECTS_FOR_SELECTED_USER:
      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          loading: true,
          items:
            action.payload.page === 1 || action.payload.page === undefined
              ? []
              : state.projectsForSelectedUserList.items,
        },
      };
    case GET_PROJECTS_FOR_SELECTED_USER_SUCCEEDED:
      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          lastSortUsed: action.payload.lastSortUsed,
          loading: false,
          items: [
            ...state.projectsForSelectedUserList.items,
            ...action.payload.projects,
          ],
          total: action.payload.total,
        },
      };
    case GET_PROJECTS_FOR_SELECTED_USER_FAILED:
      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          loading: false,
          items: [],
          total: 0,
        },
      };
    case ASSIGN_USER_AS_ORG_ADMIN_SUCCEEDED:
      return {
        ...state,
        selectedUser: {
          ...state.selectedUser,
          isOrgAdmin: action.payload.isOrgAdmin,
        },
      };
    case SET_USER_FAVORITE_REPORT: {
      const { reportId, newValue } = action.payload;
      const reportFavoritedIndex = state.reportsForSelectedUserList.items.findIndex(
        ({ id }) => id === reportId
      );

      return {
        ...state,
        reportsForSelectedUserList: {
          ...state.reportsForSelectedUserList,
          items: [
            ...state.reportsForSelectedUserList.items.slice(
              0,
              reportFavoritedIndex
            ),
            {
              ...state.reportsForSelectedUserList.items[reportFavoritedIndex],
              isMarkedAsFavoriteByUser: newValue,
            },
            ...state.reportsForSelectedUserList.items.slice(
              reportFavoritedIndex + 1
            ),
          ],
        },
      };
    }
    case SET_USER_FAVORITE_PROJECT: {
      const { projectId, newValue } = action.payload;
      const projectFavoritedIndex = state.projectsForSelectedUserList.items.findIndex(
        ({ id }) => id === projectId
      );

      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          items: [
            ...state.projectsForSelectedUserList.items.slice(
              0,
              projectFavoritedIndex
            ),
            {
              ...state.projectsForSelectedUserList.items[projectFavoritedIndex],
              isMarkedAsFavoriteByUser: newValue,
            },
            ...state.projectsForSelectedUserList.items.slice(
              projectFavoritedIndex + 1
            ),
          ],
        },
      };
    }
    case CHANGE_PROJECT_OWNER: {
      const { projectId, projectOwner } = action.payload;
      const index = state.projectsForSelectedUserList.items.findIndex(
        ({ id }) => id === projectId
      );

      const items = [...state.projectsForSelectedUserList.items];
      items[index].projectOwner = projectOwner;

      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          items,
        },
      };
    }
    case REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_SUCCEEDED: {
      const { projects, total, startingPage } = action.payload;
      const positionToStartReplacing =
        (startingPage - 1) * USER_PROJECT_ITEMS_PER_PAGE;

      return {
        ...state,
        projectsForSelectedUserList: {
          ...state.projectsForSelectedUserList,
          total,
          items: [
            ...state.projectsForSelectedUserList.items.slice(
              0,
              positionToStartReplacing
            ),
            ...projects,
          ],
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
